/* tslint:disable */
/* eslint-disable */
export enum WorkTaskStatusEnum {
  Geplant = 'Geplant',
  Definitiv = 'Definitiv',
  Erledigt = 'Erledigt',
  Abgelehnt = 'Abgelehnt',
  Freigegeben = 'Freigegeben'
}
